import type { MissionSource } from "./mission-api.js";
import { MissionSourceSchema } from "./mission-api.js";

/** Capture links carry only a source reference. The server resolves its private context. */
export function missionCapturePath(source: MissionSource, mobile = false) {
  return `${mobile ? "/mission-new" : "/app/missions"}?source=${encodeURIComponent(JSON.stringify(source))}`;
}
export function parseMissionCapture(value: string | null | undefined): MissionSource | null {
  if (!value) return null;
  try {
    return MissionSourceSchema.parse(JSON.parse(value));
  } catch {
    throw new Error("This mission source link is invalid.");
  }
}
